import { AutogenLayoutProject44ProfileList } from "./autogen/AutogenLayoutProject44ProfileList";

export class Project44ProfileList extends AutogenLayoutProject44ProfileList {
    override onLoad() {
        this.mainDataSource.search({});
    }
}
